import React from "react";
import styles from "./style.module.css";

import { Button } from "aible";

export default class HorizontalList extends React.Component {
  constructor(props) {
    super(props);
  }

  handleClick(key) {
    const { setSelectedMode, names } = this.props;
    setSelectedMode(key);
  }

  renderStyle(key) {
    const { selectedMode } = this.props;
    return key == selectedMode ? styles.selectedButton : styles.unselectedButton;
  }

  render() {
    const { names } = this.props;

    let filterNames = names.filter((n) => {
      return n !== undefined;
    });
    return (
      <div className={styles.buttonSlider}>
        <ul>
          {filterNames.map((name, idx) => {
            return (
              <li>
                <Button onClick={() => this.handleClick(idx)} className={this.renderStyle(idx)}>
                  {name.label}
                </Button>
              </li>
            );
          })}
          <li>
            <Button onClick={() => this.handleClick("Overall")} className={this.renderStyle("Overall")}>
              {"Overall"}
            </Button>
          </li>
          {/* <li><Button onClick={() => this.handleClick("Marketing")}
                                className={this.renderStyle("Marketing")}>{"Marketing"}</Button></li>

                    <li><Button onClick={() => this.handleClick("Sales")}
                                className={this.renderStyle("Sales")}>{"Sales"}</Button></li>

                    <li><Button onClick={() => this.handleClick("Services")}
                                className={this.renderStyle("Services")}>{"Services"}</Button></li>

                    <li><Button onClick={() => this.handleClick("Other")}
                                className={this.renderStyle("Other")}n>{"Other"}</Button></li> */}
        </ul>
      </div>
    );
  }
}
